<script setup lang="ts">
defineProps<{ legend: string }>()
</script>

<template>
  <fieldset class="form-section">
    <legend>{{ legend }}</legend>
    <slot />
  </fieldset>
</template>

<style scoped>
.form-section {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  min-width: 0;
  margin: 0;
  padding: var(--space-4) var(--space-6) var(--space-6);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  background: var(--color-surface);
}

legend {
  padding: 0 var(--space-2);
  margin-left: calc(-1 * var(--space-2));
  font-weight: 600;
}

@media (max-width: 36rem) {
  .form-section {
    padding: var(--space-3) var(--space-4) var(--space-4);
  }
}
</style>
